import React, { createContext, PropsWithChildren } from 'react';
import environment from '@/environments/environment';

export interface RouteConfigContextType {
  basePath: string;
}

export const RouteConfigContext = createContext<RouteConfigContextType | undefined>(undefined);

interface RouteConfigProviderProps extends PropsWithChildren {
  /**
   * The base path for the microfrontend
   * This is provided by the host application and used for dynamic routing
   */
  basePath?: string;
}

/**
 * Provider component that makes basePath available throughout the app
 */
export const RouteConfigProvider = ({ children, basePath }: RouteConfigProviderProps) => {
  //console.log("==basePath==", basePath);
 // console.log("==environment.IS_RUNNING_STAND_ALONE==", environment.IS_RUNNING_STAND_ALONE);
  const finalBasePath = basePath ?? (environment.IS_RUNNING_STAND_ALONE ? '' : '/app');
  return (
    <RouteConfigContext.Provider value={{ basePath: finalBasePath }}>
      {children}
    </RouteConfigContext.Provider>
  );
};
